import { render } from "./LiveBalance.vue?vue&type=template&id=40148af4"
import script from "./LiveBalance.vue?vue&type=script&lang=js"
export * from "./LiveBalance.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__